import {common} from './vi/common';

const Vietnamese = {
    ...common
}
export default Vietnamese
